import createLucideIcon from '../createLucideIcon';

const Send = createLucideIcon('Send', [
  ['line', { x1: '22', x2: '11', y1: '2', y2: '13', key: '2qtwb' }],
  ['polygon', { points: '22 2 15 22 11 13 2 9 22 2', key: '12uapv' }],
]);

export default Send;
